<template>
  <el-container>
    <el-main style="width: 100%; height: 100%">
      <div style="margin-bottom: 30px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="item_font">系统设置</el-breadcrumb-item>
          <el-breadcrumb-item
            ><span class="item_font">对话分配规则</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>

      <div class="menu">
        <el-tabs v-model="menu" type="card">
          <el-tab-pane label="常规" name="common"></el-tab-pane>
          <el-tab-pane label="全局规则" name="all"></el-tab-pane>
          <!-- <el-tab-pane
            v-if="multihospdepState == 1"
            label="多科室规则"
            name="multihospdep"
          ></el-tab-pane> -->
        </el-tabs>
      </div>
      <div v-if="menu == 'common'" class="same">
        <TalkCommon @changeNum="changeNum"></TalkCommon>
      </div>
      <div v-if="menu == 'part'" class="same">
        <TalkPart
          :userLst="userLst"
          :text1="text1"
          :text2="text2"
          @changeNum="changeNum"
          :check="check"
          @save="save"
          :item2="item2"
        ></TalkPart>
      </div>

      <div v-if="menu == 'all'" class="same">
        <GlobalRule @changeNum="changeNum"></GlobalRule>
      </div>

      <div v-if="menu == 'multihospdep'" class="same">
        <TalkMultihospdep :csid="id" @changeNum="changeNum"></TalkMultihospdep>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import TalkCommon from "../../components/TalkCommon/index.js";
import TalkPart from "../../components/TalkPart/index.js";
import GlobalRule from "../../components/GlobalRule/index.js";
import TalkMultihospdep from "../../components/TalkMultihospdep/index.js";
export default {
  data() {
    return {
      menu: "common",
      // userLst: [],
      queryUserLst: [],
      item: "",
      // item1: {
      //   max: null,
      //   stress: null,
      //   maxsessin: 0,
      // },
      item2: {
        isUse: false,
        text1: "",
        text2: "",
      },
      tt: false,
      text1: "",
      text2: "",
      check: false,
      id: "",
      // first: false,
      customerName: "",
      customTotal: 1,
      index: 0,
      user: false,
      value: "请选择客服",
      name: "",
      changeItem: null,
      originItem: {},
      isSave: false,
      multihospdepState: null,
      // tableData: [
      //   {
      //     name: "客服",
      //     sort: "排序",
      //     weight: "权重",
      //     maxFlow: "同时最大流量",
      //     maxDialogue: "当日最大对话量",
      //     elasticUpperLimit: "弹性上限",
      //     channel: "渠道",
      //     promotedAccounts: "推广账户",
      //     onlyAllocateAreas: "区域（只分配）",
      //     noAllocateAreas: "区域（不分配）",
      //     onlyAllocateKeys: "关键词（只分配）",
      //     noAllocateKeys: "关键词（不分配）",
      //   },
      //   {
      //     name: "客服",
      //     sort: "排序",
      //     weight: "权重",
      //     maxFlow: "同时最大流量",
      //     maxDialogue: "当日最大对话量",
      //     elasticUpperLimit: "弹性上限",
      //     channel: "渠道",
      //     promotedAccounts: "推广账户",
      //     onlyAllocateAreas: "区域（只分配）",
      //     noAllocateAreas: "区域（不分配）",
      //     onlyAllocateKeys: "关键词（只分配）",
      //     noAllocateKeys: "关键词（不分配）",
      //   },
      //   {
      //     name: "客服",
      //     sort: "排序",
      //     weight: "权重",
      //     maxFlow: "同时最大流量",
      //     maxDialogue: "当日最大对话量",
      //     elasticUpperLimit: "弹性上限",
      //     channel: "渠道",
      //     promotedAccounts: "推广账户",
      //     onlyAllocateAreas: "区域（只分配）",
      //     noAllocateAreas: "区域（不分配）",
      //     onlyAllocateKeys: "关键词（只分配）",
      //     noAllocateKeys: "关键词（不分配）",
      //   },
      //   {
      //     name: "客服",
      //     sort: "排序",
      //     weight: "权重",
      //     maxFlow: "同时最大流量",
      //     maxDialogue: "当日最大对话量",
      //     elasticUpperLimit: "弹性上限",
      //     channel: "渠道",
      //     promotedAccounts: "推广账户",
      //     onlyAllocateAreas: "区域（只分配）",
      //     noAllocateAreas: "区域（不分配）",
      //     onlyAllocateKeys: "关键词（只分配）",
      //     noAllocateKeys: "关键词（不分配）",
      //   },
      //   {
      //     name: "客服",
      //     sort: "排序",
      //     weight: "权重",
      //     maxFlow: "同时最大流量",
      //     maxDialogue: "当日最大对话量",
      //     elasticUpperLimit: "弹性上限",
      //     channel: "渠道",
      //     promotedAccounts: "推广账户",
      //     onlyAllocateAreas: "区域（只分配）",
      //     noAllocateAreas: "区域（不分配）",
      //     onlyAllocateKeys: "关键词（只分配）",
      //     noAllocateKeys: "关键词（不分配）",
      //   },
      // ],
      // editDialogVisible: true,
      // formData: {
      //   weight: null,
      //   maxFlow: null,
      //   maxDialogue: 0,
      //   elasticUpperLimit: false,
      //   channel: [],
      // },
      // rules: {
      //   weight: [
      //     { type: "number", message: "权重值必须为数字" },
      //     { validator: weightCheck, trigger: "blur" },
      //   ],
      //   maxFlow: [
      //     { type: "number", message: "最大流量必须为数字" },
      //     { validator: maxFlowCheck, trigger: "blur" },
      //   ],
      //   maxDialogue: [
      //     { type: "number", message: "最大会话量必须为数字" },
      //     { validator: maxDialogueCheck, trigger: "blur" },
      //   ],
      // },
      // sourceList: [
      //   {
      //     label: "百度",
      //     value: 1,
      //   },
      //   {
      //     label: "360",
      //     value: 2,
      //   },
      //   {
      //     label: "搜狗",
      //     value: 3,
      //   },
      //   {
      //     label: "神马",
      //     value: 4,
      //   },
      //   {
      //     label: "其他",
      //     value: 0,
      //   },
      // ],

      // adUserIdList: [],
      // checkAreaRule: false,
      // keysAreaRule:false
    };
  },
  components: {
    TalkCommon,
    TalkPart,
    GlobalRule,
    // KWrule,
    // TalkSource,
    // TalkAduser,
    TalkMultihospdep,
  },
  mounted() {
    // this.partRule();
    this.getMultihospdepState();

    // this.commonSelect()
  },
  methods: {
    // 获取推广账号列表
    // async getPromotedAccounts() {
    //   var api = "/manager/aduserRelation/selectList";
    //   const response = await this.util.postRequest({
    //     url: api,
    //     method: "POST",
    //     data: {},
    //   });
    //   if (response.resultCode == 10000) {
    //     this.adUserIdList = response.data;
    //   } else {
    //     this.$message.error(response.desc);
    //   }
    // },
    // // 弹性上限开关
    // elasticSwitch(blo) {
    //   this.formData.elasticUpperLimit = blo;
    // },
    // // 保存表格
    // editDialogSave() {
    //   this.editDialogVisible = false;
    // },
    // //  编辑表格
    // editDialogTable(a, b, c) {
    //   this.editDialogVisible = true;
    //   console.log(a, b, c);
    // },
    // // 表格单元格样式
    // tableCellStyle() {
    //   return "text-align:center";
    // },
    // // 表格表头样式
    // tableHeaderClassName(e) {
    //   console.log("TalkRule,vue tableHeaderClassName e:", e);
    //   return "tableHeaderClass";
    // },
    // // 表格索引
    // indexMethod(index) {
    //   return index + 1;
    // },
    async partRule() {
      // 查询客服列表
      var api = "/manager/sessStgyRegion/selectCustList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      this.userLst = response.data;
      this.customTotal = this.userLst.length - 1;
      if (this.customerName === "") {
        this.customerName = this.userLst[0].realName;
        this.id = this.userLst[0].id;
        this.index = 0;
        // this.commonSelect(this.userLst[0].id);
      }
      console.log("*****partRule response = *****", response.data);
    },
    // 获取多科室状态
    async getMultihospdepState() {
      var api = "/manager/sysconf/get/multihospdep/state";
      const response = await this.util.postRequest({
        url: api,
        method: "GET",
        data: {},
      });
      console.log("*****getMultihospdepState response = *****", response.data);
      this.multihospdepState = response.data;
    },

    // async commonSelect(id) {
    //   // 查询当前常规配置
    //   // console.log(111111,id)
    //   // this.first == true;
    //   var api = "/manager/sessStgyGeneral/selectById";
    //   const response = await this.util.postRequest({
    //     url: api,
    //     method: "POST",
    //     data: {
    //       csid: id,
    //     },
    //   });
    //   console.log("*****commonSelect response = *****", response.data);
    //   if (response.data.data == null) {
    //     console.log("数据还未设置");
    //     this.item1 = {
    //       max: "",
    //       stress: "",
    //       id: "",
    //       csid: this.item.id,
    //       sp: false,
    //     };
    //     // this.tt=false
    //     // this.commonEdit(this.item1)
    //   } else {
    //     console.log("数据已经设置");
    //     this.item1 = response.data.data;
    //     if (this.item1.sp == "0") {
    //       this.item1.sp = false;
    //       // this.tt=false
    //     } else {
    //       this.item1.sp = true;
    //       // this.tt=true
    //     }
    //     this.item1.stress = Number(this.item1.stress);
    //     this.item1.max = Number(this.item1.max);
    //     this.item1.maxsessin = Number(this.item1.maxsessin);
    //     console.log("传递的item1值:", this.item1, this.item1.sp);
    //     // this.partRule()
    //   }
    //   this.originItem = JSON.parse(JSON.stringify(this.item1));
    //   console.log(this.originItem);
    // },

    // async sourceSelect(id){

    // },

    // async commonEdit(item) {
    //   // 编辑当前常规配置
    //   var api = "/manager/sessStgyGeneral/addOrEdit";
    //   const response = await this.util.postRequest({
    //     url: api,
    //     method: "POST",
    //     data: {
    //       id: item.id,
    //       csid: this.id,
    //       max: item.max,
    //       stress: item.stress,
    //       maxsessin: item.maxsessin,
    //       sp: item.sp,
    //     },
    //   });
    //   console.log("*****commonEdit response = *****", response);
    //   this.item1 = response.data;
    //   if (response.desc == "success") {
    //     this.open1();
    //     this.commonSelect(item.csid);
    //     this.changeItem = null;
    //   } else {
    //     this.open2(response.desc);
    //   }
    // },
    async quyuSelect(id) {
      // 查询客服区域规则
      var api = "/manager/sessStgyRegion/selectRegionList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          csid: id,
        },
      });
      console.log("*****quyuRule response = *****", response.data);
      if (response.data == {}) {
        this.item2 = {
          isUse: 0,
          autoContentList: [{}],
          noAutoContentList: [{}],
          csid: this.item.id,
        };
        // this.quyuEdit(this.item2)
      } else {
        this.item2 = response.data;
        if (this.item2.isUse === 0) {
          this.item2.isUse = false;
          this.check = false;
        } else {
          this.item2.isUse = true;
          this.check = true;
        }
        if (this.item2.autoContentList != null) {
          var arr1 = [];
          for (var i = 0; i < this.item2.autoContentList.length; i++) {
            console.log(
              "this.item2.autoContentList,",
              this.item2.autoContentList[i].content
            );
            arr1.push(this.item2.autoContentList[i].content);
          }
          var str1 = arr1.toString().replace(/,/g, " ");
          this.item2["text1"] = str1;
          this.text1 = str1;
        } else {
          this.item2["text1"] = "";
          this.text1 = "";
        }
        if (this.item2.noAutoContentList != null) {
          var arr2 = [];
          for (var k = 0; k < this.item2.noAutoContentList.length; k++) {
            console.log(
              "this.item2.autoContentList,",
              this.item2.noAutoContentList[k].content
            );
            arr2.push(this.item2.noAutoContentList[k].content);
          }
          var str2 = arr2.toString().replace(/,/g, " ");
          this.item2["text2"] = str2;
          this.text2 = str2;
        } else {
          this.item2["text2"] = "";
          this.text2 = "";
        }
        console.log("传递的item2值:", this.item2);
        console.log(11111111, this.text1, this.text2);
        this.originItem = JSON.parse(JSON.stringify(this.item2));
        console.log(this.originItem);
        // this.partRule()
      }
    },
    async quyuEdit(item) {
      // 编辑客服区域规则
      var api = "/manager/sessStgyRegion/add";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          csid: this.id,
          isUse: item.isUse,
          autoContentList: item.autoContentList,
          noAutoContentList: item.noAutoContentList,
        },
      });
      console.log("*****quyuRule response = *****", response);
      if (response.desc === "success") {
        this.open1();
        this.changeItem = null;
      } else {
        this.open2(response.desc);
      }
      // this.quyuSelect()
    },
    // beforeHandle(tab) {
    //   console.log(tab);
    //   if (this.menu == "common") {
    //     console.log(this.changeItem);
    //     console.log(this.originItem);
    //     if (this.changeItem) {
    //       if (
    //         this.changeItem.stress != this.originItem.stress ||
    //         this.changeItem.max != this.originItem.max ||
    //         this.changeItem.maxsessin != this.originItem.maxsessin ||
    //         this.changeItem.sp != this.originItem.sp
    //       ) {
    //         this.$message.warning("请先保存信息");
    //         return false;
    //       }
    //     } else {
    //       this.handleClick(tab);
    //     }
    //   }
    //   if (this.menu == "part") {
    //     console.log(this.changeItem);
    //     console.log(this.originItem);
    //     if (this.changeItem) {
    //       if (
    //         this.changeItem.text1 != this.originItem.text1 ||
    //         this.changeItem.text2 != this.originItem.text2 ||
    //         this.changeItem.check != this.originItem.isUse
    //       ) {
    //         this.$message.warning("请先保存信息");
    //         return false;
    //       }
    //     }
    //     this.handleClick(tab);
    //   }
    //   if (this.menu == "key" || this.menu == "all") {
    //     console.log(this.isSave);
    //     if (this.isSave) {
    //       this.$message.warning("请先保存信息");
    //       return false;
    //     }
    //     this.handleClick(tab);
    //   }

    //   if (this.menu == "source") {
    //     this.handleClick(tab);
    //   }
    //   if (this.menu == "aduser") {
    //     this.handleClick(tab);
    //   }
    // },
    // handleClick(tab) {
    //   this.changeItem = null;
    //   /*console.log('选择菜单：', tab.name);
    // 		this.menu = tab.name
    // 		if(tab.name=="common"){
    // 			this.commonSelect(this.id)
    // 		}else if(tab.name=="part"){
    // 			this.quyuSelect(this.id)
    // 		}*/
    //   console.log("选择菜单：", tab);
    //   // this.menu = tab
    //   if (tab == "common") {
    //     this.commonSelect(this.id);
    //   } else if (tab == "part") {
    //     this.quyuSelect(this.id);
    //   }
    // },
    cellStyle1() {
      return "text-align:left;height:20px;line-height:20px";
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    checkUser(row) {
      console.log("*** checkUser ***", row, this.index);
      // localStorage.setItem('customer',row)
      this.value = row.realName;
      this.item = row;
      this.user = false;
      this.show = true;
      this.id = row.id;
      this.customerName = row.realName;
      for (let i = 0, len = this.userLst.length; i < len; i++) {
        if (this.userLst[i].realName == row.realName) {
          this.index = i;
        }
      }
      this.queryUserLst = [];
      if (this.menu === "part") {
        this.quyuSelect(row.id);
      }
    },

    changeNum(info) {
      console.log("TalkRule changeNum info:", info);
      if (info.tableName == "key" || info.tableName == "all") {
        this.isSave = info.isSave;
      } else if (info.tableName == "part") {
        this.item2 = {
          autoContentList: info.arr1,
          noAutoContentList: info.arr2,
          isUse: info.check,
          text1: info.text1,
          text2: info.text2,
        };
        console.log("info.item", this.item2);
      } else {
        if (info.tableName == "commom") {
          if (info.item.sp == "0") {
            info.item.sp = false;
          } else {
            info.item.sp = true;
          }
        }
        this.changeItem = JSON.parse(JSON.stringify(info.item));
      }
      console.log(this.isSave);
    },
    save(info) {
      if (info.tableName == "part") {
        var autoContentList = [];
        var noAutoContentList = [];
        var obj = {};
        this.text1 = info.text1;
        this.text2 = info.text2;
        if (info.check == false) {
          this.check = false;
          obj["isUse"] = 0;
        } else {
          this.check = true;
          obj["isUse"] = 1;
        }
        for (var i = 0; i < info.arr1.length; i++) {
          var obj1 = {};
          obj1["content"] = info.arr1[i];
          autoContentList.push(obj1);
        }
        for (var k = 0; k < info.arr2.length; k++) {
          var obj2 = {};
          obj2["content"] = info.arr2[k];
          noAutoContentList.push(obj2);
        }
        obj["autoContentList"] = autoContentList;
        obj["noAutoContentList"] = noAutoContentList;
        console.log("处理数据后保存到区域设置的值", obj, this.id);
        this.quyuEdit(obj);
      }
    },
    open1() {
      const tipMsg = "保存成功";
      this.$message.success(tipMsg);
    },
    open2(info) {
      const text = info + "保存失败";
      this.$message.error(text);
    },
    selsecUser() {
      this.partRule();
      this.name = "";
      this.user = true;
    },
    perCustomer() {
      if (this.index > 0) {
        this.index = this.index - 1;
      }
      console.log("perCustomer", this.index);
      // localStorage.setItem('customer',this.userLst[this.index])
      this.item = this.userLst[this.index];
      this.id = this.item.id;
      this.customerName = this.item.realName;
      // if (this.menu === "common") {
      //   this.commonSelect(this.item.id);
      // } else if (this.menu === "part") {
      //   this.quyuSelect(this.item.id);
      // }
      if (this.menu === "part") {
        this.quyuSelect(this.item.id);
      }
      //   if (
      //     this.changeItem &&
      //     (this.changeItem.stress != this.originItem.stress ||
      //       this.changeItem.max != this.originItem.max ||
      //       this.changeItem.maxsessin != this.originItem.maxsessin ||
      //       this.changeItem.sp != this.originItem.sp)
      //   ) {
      //     this.$message.warning("请先保存信息");
      //     return false;
      //   } else {
      //     if (this.index > 0) {
      //       this.index = this.index - 1;
      //     }
      //     console.log("perCustomer", this.index);
      //     // localStorage.setItem('customer',this.userLst[this.index])
      //     this.item = this.userLst[this.index];
      //     this.id = this.item.id;
      //     this.customerName = this.item.realName;
      //     if (this.menu === "common") {
      //       this.commonSelect(this.item.id);
      //     } else if (this.menu === "part") {
      //       this.quyuSelect(this.item.id);
      //     }
      //   }
    },
    nextCustomer() {
      if (this.index < this.customTotal) {
        this.index = this.index + 1;
      }
      console.log("nextCustomer", this.index);
      console.log("this.item", this.userLst[this.index]);
      // localStorage.setItem('customer',this.userLst[this.index])
      this.item = this.userLst[this.index];
      this.id = this.item.id;
      this.customerName = this.item.realName;
      // if (this.menu === "common") {
      //   this.commonSelect(this.item.id);
      // } else if (this.menu === "part") {
      //   this.quyuSelect(this.item.id);
      // }
      if (this.menu === "part") {
        this.quyuSelect(this.item.id);
      }
      //   if (
      //     this.changeItem &&
      //     (this.changeItem.stress != this.originItem.stress ||
      //       this.changeItem.max != this.originItem.max ||
      //       this.changeItem.maxsessin != this.originItem.maxsessin ||
      //       this.changeItem.sp != this.originItem.sp)
      //   ) {
      //     this.$message.warning("请先保存信息");
      //     return false;
      //   } else {
      //     if (this.index < this.customTotal) {
      //       this.index = this.index + 1;
      //     }
      //     console.log("nextCustomer", this.index);
      //     console.log("this.item", this.userLst[this.index]);
      //     // localStorage.setItem('customer',this.userLst[this.index])
      //     this.item = this.userLst[this.index];
      //     this.id = this.item.id;
      //     this.customerName = this.item.realName;
      //     if (this.menu === "common") {
      //       this.commonSelect(this.item.id);
      //     } else if (this.menu === "part") {
      //       this.quyuSelect(this.item.id);
      //     }
      //   }
    },
    closeUser() {
      this.name = "";
      // console.log(11111111111, this.name);
    },
    querySearch(queryString, cb) {
      var userLst = this.userLst;
      var results = queryString
        ? userLst.filter(this.createFilter(queryString))
        : userLst;
      console.log("查询结果", queryString, results);
      if (results.length == 0) {
        results = [
          {
            realName: "未搜索到数据",
          },
        ];
      }
      this.$emit("restart", {
        tableName: "commom",
      });
      cb(results);
    },
    createFilter(queryString) {
      return (data) => {
        console.log(
          "data.realName.toLowerCase().indexOf(queryString.toLowerCase())",
          data.realName.toLowerCase().indexOf(queryString.toLowerCase())
        );
        return (
          data.realName.toLowerCase().indexOf(queryString.toLowerCase()) !== -1
        );
      };
    },
    handleSelect(item) {
      console.log(111, item);
      this.name = item.realName;

      this.queryUserLst = [];
      this.queryUserLst.push(item);
      // this.userLst = []
      // this.userLst.push(item)
      // console.log('userLst', this.userLst)
      // this.customTotal = this.userLst.length-1
    },
    inputNothing(val) {
      console.log("输入值发生改变", val);
      if (val == "") {
        this.partRule();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep  .tableBox {
  width: 100%;
  table-layout: auto;
  .el-table__cell {
    // width: auto !important;
    // white-space: nowrap;
    min-width: 0;
  }
  .tableHeaderClass th:first-child {
    min-width: 60px;
  }
  .tableHeaderClass {
    color: #000 !important;
    font-weight: 600;
    @include change_size($font_size_normal);
  }
  .sort-imgBox {
    text-align: center;
    img {
      width: 20px;
      height: 20px;
      cursor: pointer;
      &:first-child {
        margin-right: 10px;
      }
    }
    // &>img:first-child{
    //     margin-right: 10px;
    // }
  }
}

// 表格编辑弹出窗样式
::v-deep .tableEditDialog {
  .el-form-item__label {
    text-align: right;
    // margin-left: 2em;
    min-width: 150px;
  }
  .tableEditDialog-item {
    display: flex;
    .tableEditDialog-text {
      margin-left: 10px;
      line-height: 40px;
      color: #969696;
      font-size: 14px;
    }
  }
  .commonFlex {
    .el-form-item__content {
      flex: 1;
    }
  }

  .el-form-item__content {
    display: flex;
    .el-input {
      margin-left: 0 !important;
    }
  }
  .el-dialog__body {
    max-height: 60vh;
    overflow-y: auto;
  }
  .el-dialog__title::before {
    display: block;
    content: "";
    width: 3px;
    height: auto;
    background-color: #1577d2;
    margin-right: 6px;
  }

  .el-dialog__title {
    display: flex;
    color: #000;
    font-weight: 600;
    line-height: 1;
    @include change_title_size($title_size_normal);
  }
  .el-dialog__footer {
    text-align: center;
  }
  .tableEditDialog-title {
    font-weight: 600;
    color: #000;
    @include change_title_size($title_size_normal);
  }
}
</style>
<style>
.menu {
  width: 40%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 30px;
  line-height: 30px;
  margin-bottom: 30px;
  font-size: 14px;
  @include change_size($font_size_normal);
}

.el-checkbox__label {
  @include change_size($font_size_normal);
}
</style>
